import React from 'react';

const ResultsCount = ({ filtered, total, loading }) => (
  <div className="text-sm text-gray-600 my-2">
    Showing {filtered} of {total} accounts
    {loading && <span className="ml-2 text-orange-500 animate-pulse">(Refreshing...)</span>}
  </div>
);

export default ResultsCount; 